export const discountsSearchSettings = {
  limit: 20,
  offset: 20,
};
